import React, { useState, useEffect } from "react";
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

export default function AppUsersList() {
    const [appUsers, setAppUsers] = useState([]);
    const { secureFetch } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUsers = async () => {
            const response = await secureFetch('api/auth/AppUser/list');
            if (response.ok) {
                const data = await response.json();
                setAppUsers(data);
            }
        };
        fetchUsers();
    }, [secureFetch]);

    const createAppUser = () => {
        navigate('/admin/appusers/add');
    };

    const editAppUser = (id) => {
        navigate('/admin/appusers/edit/' + id);
    };

    const deleteAppUser = async (selUser) => {
        if (window.confirm(`Are you sure you want to delete the app user: ${selUser.userName}?`)) {
            const response = await secureFetch(`api/auth/appuser/delete/${selUser.id}`, {
                method: 'GET'
            });
            if (response.ok) {
                alert('User deleted successfully');
                setAppUsers(appUsers.filter(r => r.id !== selUser.id));
            } else {
                alert("Failed to delete user.");
            }
        }
    };

    return (
        <>
            <div style={{ display: 'flex' }} >
                <h2 style={{ flexGrow: 1 }} >Application Users List</h2>
                <div>
                    <a class="btn btn-primary" href="javascript:void(0)" onClick={createAppUser}>
                        Create Application User
                    </a>
                </div>
            </div>

            {appUsers && appUsers.length > 0 &&
                <table class="table">
                    <thead>
                        <tr>
                            <th>Owner App</th>
                            <th>User Name</th>
                            <th>Created Date</th>
                            <th>Expiry Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {appUsers.map((item) => (
                            <tr key={item.id}>
                                <td>{item.owner}</td>
                                <td>{item.userName}</td>
                                <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                                <td>{new Date(item.expiresAt).toLocaleDateString()}</td>
                                <td>
                                    <a href="Javascript:void(0);" onClick={() => editAppUser(item.id)}>Edit</a>
                                    <span className="ms-3">|</span>
                                    <a className="ms-3" href="Javascript:void(0);" onClick={() => deleteAppUser(item)}>Delete</a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        </>
    );
}